<template>
  <div class="app-container">
    请点击右上角，使用至浏览器打开
  </div>
</template>

<script>
import {baseUrl} from "@/config/env";

export default {
  name: "handheldDownload",
  data() {
    return {
      downloadType: "",
    }
  },
  mounted() {
    // 判断是否在微信中打开
    const type = this.$route.query.handsetOrPhone
    const ua = navigator.userAgent.toLowerCase();
    const isWeixin = ua.indexOf('micromessenger') !== -1;

    // 如果在微信中打开
    if (isWeixin) {
      // 判断浏览器类型
      const isAndroid = ua.indexOf('android') !== -1;
      const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      // 如果是 iOS 设备
      if (isIOS) {
        this.showToast('请点击右上角菜单，在浏览器中打开。')
        // 隐藏页面内容
        document.documentElement.style.display = 'none'
      }

      // 如果是 Android 设备
      if (isAndroid) {
        this.showToast('请点击右上角菜单，在浏览器中打开。')

        // 监听页面 visibilitychange 事件，当用户回到页面后再显示页面内容
        document.addEventListener('visibilitychange', () => {
          document.documentElement.style.display = 'block'
        })
      }
    }else {
      // 直接下载安装包
      window.location.href = `${baseUrl}/platform/handset/apkDownload?handsetOrPhone=${type}`
    }
  },
  methods: {
    showToast(message) {
      // 显示提示信息
      const toast = document.createElement('div')
      toast.innerText = message
      toast.style.position = 'fixed'
      toast.style.top = '50%'
      toast.style.left = '50%'
      toast.style.transform = 'translate(-50%, -50%)'
      toast.style.fontSize = '16px'
      toast.style.padding = '10px'
      toast.style.borderRadius = '5px'
      toast.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'
      toast.style.color = '#fff'
      toast.style.zIndex = '9999'
      document.body.appendChild(toast)
    }
  }
}
</script>

<style scoped>

</style>
